module.exports = __webpack_public_path__ + "media/images/flags/cc-bd16a37d6802bce8a5d4035e5accb6ad.svg";